import React from "react";
import { View, StyleSheet, StyleProp, ViewStyle } from "react-native";

// Web / TV counterpart of `glass.tsx` — same API, no native-only imports.
// See the header comment there for why this split exists.

type BackdropProps = {
  style?: StyleProp<ViewStyle>;
  blurAmount?: number;
  fallbackColor?: string;
};

export function GlassBackdrop({
  style,
  blurAmount = 22,
  fallbackColor = "rgba(255,250,243,0.9)",
}: BackdropProps) {
  return (
    <View
      style={[
        style ?? StyleSheet.absoluteFill,
        { backgroundColor: fallbackColor },
        // Modern browsers get a real frosted backdrop. Chromium 76 (the Tizen /
        // webOS floor) just ignores the property and keeps the flat tint, so
        // there's nothing to feature-detect.
        { backdropFilter: `blur(${blurAmount}px)` } as ViewStyle,
      ]}
    />
  );
}

